import { Stack, TextField } from '@mui/material'
import { useRef } from 'react'

export interface SearchResult<T> {
  query: string
  results: T[]
  isEmpty: boolean
}

export interface SearchableProps<T> {
  data: T[]
  searchable: (item: T) => string[]
  value?: string
  onSearch: (data: SearchResult<T>) => void
  label: string
}

export const Searchable = <T,>({ data, onSearch, value, searchable, label }: SearchableProps<T>) => {
  const hasSearchedInitialValue = useRef(false)

  const handleSearch = (searchTerm: string) => {
    const filteredData = data.filter((item) => {
      const terms = searchable(item).map((t) => t.toLowerCase())

      return terms.some((t) => t.includes(searchTerm.toLowerCase()))
    })

    onSearch({ query: searchTerm, results: filteredData, isEmpty: filteredData.length === 0 })
  }

  if (!hasSearchedInitialValue.current) {
    hasSearchedInitialValue.current = true

    if (value) {
      handleSearch(value)
    }
  }

  return (
    <Stack
      sx={{
        paddingTop: 1,
      }}
    >
      <TextField
        slotProps={{ input: { 'aria-label': 'search-field' } }}
        label={label}
        value={value}
        onChange={(e) => handleSearch(e.target.value)}
      />
    </Stack>
  )
}
